<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-2"><span class="CharOverride-3">T</span><span class="CharOverride-4">HE</span><span class="CharOverride-3"> Z</span><span class="CharOverride-4">ANZIBAR </span><span class="CharOverride-3"><br/>C</span><span class="CharOverride-4">HEST</span></p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-5">A Story of Life, Love, and Death <br/>in Foreign Lands</span></p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-6">A</span><span class="CharOverride-7">IDAN </span><span class="CharOverride-6">H</span><span class="CharOverride-7">ARTLEY</span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-8"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.png"/></span></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-8">Grove Press</span></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-8">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V28911.vue?14161d27